import { render, staticRenderFns } from "./HoursReport.vue?vue&type=template&id=b9d8f4b4&scoped=true&"
import script from "./HoursReport.vue?vue&type=script&lang=js&"
export * from "./HoursReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d8f4b4",
  null
  
)

export default component.exports